(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("antd"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "antd"], factory);
	else if(typeof exports === 'object')
		exports["atom-view-engine"] = factory(require("react"), require("antd"));
	else
		root["atom-view-engine"] = factory(root["React"], root["antd"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__) {
return 